import label from "@/lang/StaticLabels.js";

// PMRPVALVS Router  - برنامه ریزی تولید شیرآلات -----------------------------------------------
let routeItems = {
  path: "PMRPVALVS",
  name: "PMRPVALVS",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PMRPVALVSDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PMRPVALVSDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pmrpValvs,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpValvs/Dashboard"),
    },

    // Base Information -----------------------------------------------
    {
      path: "inspectionLevel",
      name: "PMRPVALVSInspectionLevel",
      meta: {
        label: label.page.inspectionLevel,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpValvs/base/inspectionLevel"),
    },
    {
      path: "productionGroups",
      name: "PMRPVALVSProductionGroups",
      meta: {
        label: label.page.productionGroups,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmrpValvs/base/productionGroups"),
    },
    {
      path: "purchaseContracts",
      name: "PMRPVALVSPurchaseContracts",
      meta: {
        label: label.page.purchaseContracts,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmrpValvs/base/purchaseContracts"),
    },
    {
      path: "saleType",
      name: "PMRPVALVSSaleType",
      meta: {
        label: label.page.saleType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpValvs/base/saleType"),
    },
    {
      path: "modiranMapping",
      name: "PMRPVALVSModiranMapping",
      meta: {
        label: label.page.modiranMapping,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpValvs/base/modiranMapping"),
    },
    {
      path: "systemSetting",
      name: "PMRPVALVSSystemSetting",
      meta: {
        label: label.page.settings,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmrpValvs/base/systemSetting"),
    },
    {
      path: "commodityAdditionalInfo",
      name: "PMRPVALVSCommodityAdditionalInfo",
      meta: {
        label: label.page.commodityAdditionalInfo,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmrpValvs/base/commodityAdditionalInfo"),
    },

    // Operation -----------------------------------------------
    {
      path: "order",
      name: "PMRPVALVSOrder",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/order/list",
      children: [
        {
          path: "list",
          name: "PMRPVALVSOrderList",
          component: () => import("@/views/modules/pmrpValvs/operation/order"),
          meta: {
            label: label.page.order,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PMRPVALVSAddOrder",
          meta: {
            label: label.page.addOrder,
            requiresAuth: true,
          },
          component: () =>
            import("@/views/modules/pmrpValvs/operation/order/Add"),
        },
        {
          path: "edit/:id",
          name: "PMRPVALVSEditOrder",
          component: () =>
            import("@/views/modules/pmrpValvs/operation/order/Add"),
          meta: {
            label: label.page.editOrder,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "cartable",
      name: "PMRPVALVSCartable",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "/cartable",
      children: [
        {
          path: "technical",
          name: "PMRPVALVSTechnicalCartable",
          component: () =>
            import(
              "@/views/modules/pmrpValvs/operation/cartable/TechnicalCartable.vue"
            ),
          meta: {
            label: label.page.technicalCartable,
            requiresAuth: true,
          },
        },
        {
          path: "sale",
          name: "PMRPVALVSSaleCartable",
          component: () =>
            import(
              "@/views/modules/pmrpValvs/operation/cartable/SaleCartable.vue"
            ),
          meta: {
            label: label.page.SaleCartable,
            requiresAuth: true,
          },
        },
        {
          path: "mapConfirm",
          name: "PMRPVALVMapConfirmCartable",
          component: () =>
            import(
              "@/views/modules/pmrpValvs/operation/cartable/MapConfirmCartable"
            ),
          meta: {
            label: label.page.mapConfirmCartable,
            requiresAuth: true,
          },
        },
        {
          path: "plan",
          name: "PMRPVALVMapPlanCartable",
          component: () =>
            import("@/views/modules/pmrpValvs/operation/cartable/PlanCartable"),
          meta: {
            label: label.page.planCartable,
            requiresAuth: true,
          },
        },
        {
          path: "deliveryTimeConfirm",
          name: "PMRPVALVConfirmDeliveryDate",
          component: () =>
            import(
              "@/views/modules/pmrpValvs/operation/cartable/ConfirmDeliveryDate"
            ),
          meta: {
            label: label.page.deliveryTimeConfirm,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "reservationList",
      name: "PMRPVALVSReservationList",
      component: () =>
        import("@/views/modules/pmrpValvs/operation/reservation"),
      meta: {
        label: label.page.commodityReservationList,
        requiresAuth: true,
      },
    },
  ],
};

export default routeItems;
